<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'ORDERS', pageCode: 'ALL', subPageCode: 'ADD' }">
</div>
<app-module-header [label]="btnLabel" [hideAuditBtn]="isAddOrderAllowed" [showImportExportBtn]="showImportExportBtn"
  (onBtnClick)="onAddOrder()"
  [showLastSync]="true" (onRefreshList)="onRefreshList()" [showOrderExportBtn]="(activeIndex === 2 || activeIndex === 3)"
  [orderExportBtnLabel]="btnDownloadInvoice" (orderExportBtnClick)="exportSelectedOrders()"></app-module-header>

<div appAccessProvider [accessCode]="{ menuCode: 'ORDERS', pageCode: 'ALL', subPageCode: 'LIST' }">
  <p-tabView [(activeIndex)]="activeIndex" (onChange)="tabViewChange($event)" [scrollable]="true">
    @if(isListAllAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}"
          class="tab-label" translate>lbl_all</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.ALL}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderMsg"
          [header]="deleteOrderHeaderMsg"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrder()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateOrder($event)"
          [rowItems]="[]"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity"
          (onDelete)="onOrderDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
    @if(isListActiveAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.ORDER_ACTIVE}} inline-block wh-16 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}"
          class="tab-label" translate>order.lbl_active</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.ACTIVE}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order"
          [isLoading]="isLoading"
          [totalRecords]="totalRecords"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderMsg"
          [header]="deleteOrderHeaderMsg"
          (onDelete)="onOrderDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrder()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          [rowItems]="[]"
          (setCurrentRowData)="setCurrentRowData($event)"
          (onUpdate)="onUpdateOrder($event)"
          [bulkSelectionsItems]="bulkSelectionsItems"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
    @if(isListToBeInvoicedAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.TO_BE_INVOICE}} inline-block wh-16 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 2, 'inactive-tab-label': activeIndex !== 2}"
          class="tab-label" translate>order.lbl_to_be_invoiced</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.TO_BE_INVOICED}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderMsg"
          [header]="deleteOrderHeaderMsg"
          (onDelete)="onOrderDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrder()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onUpdate)="onUpdateOrder($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity"
          [isBulkSelection]="true">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
    @if(isListCompletedAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.CIRCLE_CHECKED}} inline-block wh-16 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 3, 'inactive-tab-label': activeIndex !== 3}"
          class="tab-label" translate>order.lbl_completed</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.COMPLETED}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderMsg"
          [header]="deleteOrderHeaderMsg"
          (onDelete)="onOrderDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrder()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onUpdate)="onUpdateOrder($event)"
          [rowItems]="rowItemsCompleted"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity"
          [isBulkSelection]="true">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
    @if(isListRejectedAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-times-circle mr-2"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 4, 'inactive-tab-label': activeIndex !== 4}"
          class="tab-label" translate>order.lbl_rejected</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.REJECTED}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderMsg"
          [header]="deleteOrderHeaderMsg"
          (onDelete)="onOrderDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrder()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onUpdate)="onUpdateOrder($event)"
          [rowItems]="[]"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
  </p-tabView>
</div>
<input hidden type="file" id="upload" (change)="onChange($event)"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>